import React, { useEffect, useState } from 'react'
// import shirtFront from '../../assets/shirtFront.jpg'
// import shirtBack from '../../assets/shirtBack.jpg'
import Card from '../Card'
import styles from './plist.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFutbol } from '@fortawesome/free-regular-svg-icons'
import { Link, useParams } from 'react-router-dom'
import Navbar from '../NavbarFooter/Navbar'
import Footer from '../NavbarFooter/Footer'
import axios from 'axios'

function ProductList(props) {
  const { id } = useParams();
  // const navigate = useNavigate(); 
//   const [linkto, setLinkto] = useState("");
//   const ct = id;
//   if (ct === "65380ddac794fcf8d4778bd5") {
//     // setLinkto(`/productCustomize/${id}`);
//     setLinkto(`/productCustomize/`);
//   }
//   else {
//     setTest(ct);
//   }

//   const handleClick = (id) => {
// setTest("linkto"+id);
//   }
 
  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get(`https://sportsblendserver.netlify.app/.netlify/functions/api/displayProducts/${id}`)
      .then((res) => {
        // console.log("The photos or data are", res.data);
        setData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);


  const [colorChange, setColorchange] = useState("");
  const changeNavbarColor = () => {
    if (window.scrollY >= 10) {
      setColorchange(" rgb(70, 70, 70)");
    }
    else {
      setColorchange("");
    }
  };
  window.addEventListener('scroll', changeNavbarColor);
  return (
    <div className='mpBG'>
      <Navbar bgcolor={colorChange} />
      {/* <div className="navbar"></div> */}

      <div className={styles.mainDiv} style={{ backgroundImage: `url(${props.image})` }}>
        <div className={styles.mainDivContent}>
          <h4 className={styles.sportTitle}>{props.sportTitle}</h4><FontAwesomeIcon icon={faFutbol} />
          <h1 className={styles.Hero}>Customize Your Own {props.sportTitle} Jersey!</h1>
        </div>
      </div>

      <div className={styles.secDiv}>
        <h4 className={styles.sportTitle}>PRODUCTS</h4>
        <h1 className={styles.Hero}>Choose a product</h1>
        <p><b>Modify</b> colors, <b>add</b> numbers and names.</p>

        <div className={styles.cardsContainer}>
          {data.map(({ _id, name, price, photo }) => (
            <div key={_id}>
              <Link to={`/productCustomize/${_id}`} className='card-link'><Card customize={id === "65380ddac794fcf8d4778bd5" ? true : false} name={name} price={price} cardImage={photo && photo.length > 0 ? `https://sportsblendserver.netlify.app/.netlify/images?url=/images/${photo[0]}` : ''} overlayImage={photo && photo.length > 0 ? `https://sportsblendserver.netlify.app/.netlify/images?url=/images/${photo[1]}` : ''} /> </Link>
            </div>
          ))} 
        </div>
      </div> 
      <Footer />
    </div>
  )
}

export default ProductList